import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from "../components/Home";
import Pokemon from "../components/Pokemon";

const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path={`/pokemon/:id`} element={<Pokemon />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter;